export default function copyText(value: string) {
  window.navigator.clipboard.writeText(value);
  const message = document.createElement("textarea");
  message.value = value;
  document.body.appendChild(message);
  message.select();
  document.execCommand("copy");
  document.body.removeChild(message);
}
